import React from 'react';
import propTypes from 'prop-types';
import { usePrefs, useSitemap, useLabels } from 'wsm-common-data';

const CTAButtons = ({
	charitySubmissionUrl,
	dealerCode,
	id,
	charitySubmissionSource,
	additionalClasses = ''
}) => {
	const { viewInventoryButtonPageAlias, vehicleSpecialsButtonPageAlias } =
		usePrefs();
	const sitemap = useSitemap();
	const labels = useLabels();

	const btnList = [
		{
			label: 'WS_STL_SELECT_CHARITY',
			link: `${charitySubmissionUrl}?source=${charitySubmissionSource}&dealerId=${dealerCode}`,
			target: '_blank'
		},
		{
			label: 'WS_STL_VIEW_INVENTORY',
			link: sitemap.get(viewInventoryButtonPageAlias),
			target: ''
		},
		{
			label: 'WS_STL_VEHICLE_SPECIALS',
			link: sitemap.get(vehicleSpecialsButtonPageAlias),
			target: ''
		}
	];

	return (
		<div
			id={id}
			className={`row m-0 cta-btn-container d-sm-flex justify-content-around ${additionalClasses}`}
		>
			{btnList.map((btn) => {
				return (
					<a
						key={btn.label}
						href={btn.link}
						rel="noopener noreferrer"
						target={btn.target}
						className="
						btn 
						btn-primary 
						btn-sm
						col-xs-10
						col-sm-3 
						col-xs-offset-1
						col-sm-offset-0
						my-4
						d-block
						rounded
						cta-btn-min-width"
					>
						{labels.get(btn.label)}
					</a>
				);
			})}
		</div>
	);
};

CTAButtons.propTypes = {
	id: propTypes.string.isRequired,
	charitySubmissionUrl: propTypes.string.isRequired,
	dealerCode: propTypes.string.isRequired,
	charitySubmissionSource: propTypes.string.isRequired,
	additionalClasses: propTypes.string.isRequired
};

export default CTAButtons;
